import React from 'react';
import { useRouter } from 'next/router';
import { getFullDateWithOrdinals } from '../../../Utils/UtilFunctions';
import { SilverRates } from '../Rates/SilverRates';
import { Select } from '../Select';
import { METALS, SILVER_DATA } from '../types';
import { checkNumberSign } from '../utils';

interface RATE_CARD_PROPS {
  data: SILVER_DATA;
  cities: string[];
  selectedCity: string;
  cmsTitle?: string;
}

const SilverRateCard = ({
  data,
  cities,
  selectedCity,
  cmsTitle,
}: RATE_CARD_PROPS): JSX.Element => {
  const image1 =
    'https://assets1.cleartax-cdn.com/cleartax/images/1676370831_1gm.png';
  const image2 =
    'https://assets1.cleartax-cdn.com/cleartax/images/1676370821_1kg.png';

  const router = useRouter();

  const onCityChange = (val: string) => {
    router.push(`/${METALS.SILVER}-rate-${val}`);
  };

  return (
    <div className="bg-[#FCFAFF] p-6 border border-[#EBEBEC] rounded-md sm:p-4">
      <div className="flex justify-between gap-4 sm:flex-col-reverse">
        <div>
          <h1 className="text-gray-700 font-bold text-s-20 sm:text-center">
            <span className="capitalize">{cmsTitle}</span>
            <div className="text-s-14 text-font-200 font-normal">
              {getFullDateWithOrdinals(new Date().toDateString())}
            </div>
          </h1>
        </div>
        <div className="flex gap-4 items-start">
          <Select
            data={cities}
            onChangeHandler={onCityChange}
            selected={selectedCity}
            id="cities"
          />
        </div>
      </div>

      <div className="flex justify-between gap-2 items-center pt-4">
        <div className="w-1/2">
          <SilverRates
            image={image1}
            rate={data.ratePerGram * 1}
            change={data.change}
            sign={checkNumberSign(data.change)}
          />
        </div>
        <div className="w-1/2">
          <SilverRates
            image={image2}
            rate={data.ratePerGram * 1000}
            change={data.change}
            sign={checkNumberSign(data.change)}
          />
        </div>
      </div>
    </div>
  );
};

export { SilverRateCard };
